
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { UrlService } from '@core/services/url/url.service';

import * as Objects from '@core/objects';
// import { VersionFeedback } from '@core/models/version-feedback';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { VersionListItemMenuClick } from '@core/components/versions/list/version-list-item-menu-click';
import { FilesListItemMenuClick } from '@core/components/files/lists/files-list-item-menu-click';

import { AppRouterService } from 'app/services/app/router.service';
import { AppService } from 'app/services/app/app.service';
// import { VersionsService } from 'app/services/app/versions.service';
// service and model for new bubbles 
import { VersionSharesService } from '@core/services/version-shares/version-shares.service';
import { VersionShare } from '@core/models/version-share.model';

//TODO a interface to 
@Component({
    selector: 'project-details-logbook-properties-share-properties',
    templateUrl: './share-properties.component.html',
    styleUrls: ['./share-properties.component.scss']
})
export class ProjectDetailsLogbookEventSharePropertiesComponent implements OnInit, OnDestroy{
    protected readonly ACCESS_REQUEST_FEEDBACK = 'share_feedback';
    protected readonly ACCESS_SHARE_TRANSFER = 'share_transfer';

    // public readonly FILES_SENT = 'versions.messages.removed';
    public readonly FEEDBACK_REQUEST = 'share.feedbacks.entries.added';
    public readonly FILES_SENT = 'share.transfers.entries.added';
    public readonly FEEDBACK_UPLOAD_VERSION_REQUEST = 'share.upload-version.entries.added';



	@Input() event: Objects.LogbookEvent;

    @Input() properties: any = null;
    
    public messagePrefixUrl: string = '';

    // feedback event details needed
    public show: boolean = false;
    public feedbackPluginAccess: boolean = false;
    public transferPluginAccess: boolean = false;
    public versionShares: Array<VersionShare> = null;
    public preText: string = '';
    // TODO create object/model for event properties depending on the kind of the event should be perfect
    public shareDetails: any;
    /** structure example for options
     *
     * {
               "id":2104,
               "key":"options",
               "value":{
                  "allow_see":true,
                  "get_approval":true,
                  "get_comments":true,
                  "get_signature":true
               },
               "share":null
            }
     */
    /** structure example for email
     * {
               "id":2102,
               "key":"email",
               "value":{
                  "subject":"lorem Ipsum....",
                  "message":"Please see files for you to review."
               },
               "share":null
            },
     */
    /** structure example for files 
     * {
                    "id": 2912,
                    "key": "files",
                    "value": [
                        310547,
                        310546
                    ]
                },
     */

    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "See Artwork Details",
            key: "details",
            icon: "see-details"
        }
    ];

    public fileMenu: Array<ThreeDotsMenuItem> = [
        {
            title: "Download File",
            key: "download",
            icon: "download",
            order: 1
        },
        {
            title: "Open Preview in New Tab",
            key: "open-preview",
            icon: "see-details",
            order: 2
        },
    ];

    protected appSubscriptor: Subscription;
    protected feedbacksSubscriptor: Subscription;
    protected bubblesSubscriptor: Subscription;

    constructor(private appRouter: AppRouterService,
        private app: AppService,
        // private versionsSrv: VersionsService,
        private bubblesSrv: VersionSharesService,
        // private http: HttpClient, 
        private urlSrv : UrlService){}
    
    ngOnInit(): void {
        if(this.event != null){
            // get plugins access
            this.appSubscriptor = this.app.getSession().subscribe( (session: any) => {
                this.feedbackPluginAccess = session.options.plugins.some((pa) => pa == this.ACCESS_REQUEST_FEEDBACK);
                this.transferPluginAccess = session.options.plugins.some((pa) => pa == this.ACCESS_SHARE_TRANSFER);
                this.init();
            });
        }
    }
    ngOnDestroy(): void {
        if(this.appSubscriptor)
            this.appSubscriptor.unsubscribe();
        if(this.feedbacksSubscriptor)
            this.feedbacksSubscriptor.unsubscribe();
        if(this.bubblesSubscriptor)
            this.bubblesSubscriptor.unsubscribe();
    }
    private init() : void {

        this.shareDetails = this.properties.share_entry.share;
        // check Approval/Signature/Comments/Allow see
        if(this.event.type == this.FEEDBACK_REQUEST && this.feedbackPluginAccess){
            this.loadVersionShareBubbles(this.properties.version);
            let options = [];
            options.push(this.getOption("get_approval") ? 'Approval' : ''); 
            options.push(this.getOption("get_comments") ? 'Comments' : ''); 
            options.push(this.getOption("get_signature") ? 'Signature' : ''); 
            options.push(this.getOption("allow_see") ? 'Allow see' : '');
            // set preText with all options requested
            this.preText = options.filter((o: string) => o!= '').join('/') + " requested from ";
        }

        if(this.event.type == this.FILES_SENT && this.transferPluginAccess){
            // set preText with recipient
            this.preText = "Sent to ";
        }

        if(this.event.type == this.FEEDBACK_UPLOAD_VERSION_REQUEST && this.feedbackPluginAccess){
            this.loadVersionShareBubbles(this.properties.version);
            // set preText with the upload version mode
            this.preText =  "New version requested from ";
        }

    }

    onClickPreview(file: Objects.File){
        if (file != null && this.properties.hasOwnProperty('version') && this.properties.version != null){
            this.appRouter.navigate('/versions/'+this.properties.version.id + "/files/"+file.id);
        }        
    }

    onMenuClick(menu: VersionListItemMenuClick) {
        switch(menu.key) {
            case "details":
                // url to go to Artwork Details
                if (menu.version != null && this.properties.request != null) {
                    this.appRouter.navigate('/projects/' + this.properties.request.id + '/versions/' + menu.version.id);
                }
                break;
        }
    }

    onFileClickPreview(file: Objects.File){
        if (file == null) 
            return;
        if(this.properties.hasOwnProperty('version')){
            this.appRouter.navigate('/versions/'+this.properties.version.id + "/files/"+file.id);
        } else if(this.properties.hasOwnProperty('request')){
            this.appRouter.navigate('/projects/'+this.properties.request.id + "/files/"+file.id);  
        }
    }

    onFileMenuClick(menu: FilesListItemMenuClick) {
        switch(menu.key) {
            case "download":
                window.location.href = this.urlSrv.build('/files/'+menu.file.id);
                break;
            case "open-preview":
                if(this.properties.hasOwnProperty('version')){
                    this.appRouter.openOnNewTab('/versions/'+this.properties.version.id + '/files/'+menu.file.id);
                } else if(this.properties.hasOwnProperty('request')){
                    this.appRouter.openOnNewTab('/projects/'+this.properties.request.id + '/files/'+menu.file.id);
                }
                break;
        }
    }

    onActionDownloadClick(file: Objects.File){
        window.location.href = this.urlSrv.build('/files/'+file.id);
    }

    toggleArtworks(){
        this.show = !this.show;
    }

    // used in the html to get the email properties
    getEmailDetail(key: string ) : boolean {
        let email =  this.shareDetails?.properties.find((op) => op.key == 'email');

        return email ? email.value[key] : '';
    }

    private getOption(key: string ) : boolean {
        let options =  this.shareDetails.properties.filter((op) => op.key == 'options')[0];
        return options.value[key];
    }

    // removed due to new bubbles object VersionShare
    // protected loadFeedbacks(versions: Array<Objects.Version>) {
    //     if(!this.feedbackPluginAccess) {
    //         this.feedbacks = [];
    //         return;
    //     }

    //     this.feedbacksSubscriptor = this.versionsSrv.getFeedbacks$(versions).subscribe((feedbacks: Array<VersionFeedback>) => {
    //         this.feedbacks = feedbacks.filter((f: VersionFeedback) => f.version.id == this.properties.version.id);
    //             // this.status = this.STATUS_DONE;
    //     });
    // }

    protected loadVersionShareBubbles(version: Objects.Version): void {
        if(!this.feedbackPluginAccess) {
            this.versionShares = [];
            return;
        }
        this.bubblesSubscriptor = this.bubblesSrv.getVersionShares$(version).subscribe((vshareBubbles: Array<VersionShare>) => {
            this.versionShares = vshareBubbles;
        });
    }


}